import { render, staticRenderFns } from "./BarTabConsumptionList.vue?vue&type=template&id=38dbee1c&scoped=true&"
import script from "./BarTabConsumptionList.vue?vue&type=script&lang=js&"
export * from "./BarTabConsumptionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dbee1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38dbee1c')) {
      api.createRecord('38dbee1c', component.options)
    } else {
      api.reload('38dbee1c', component.options)
    }
    module.hot.accept("./BarTabConsumptionList.vue?vue&type=template&id=38dbee1c&scoped=true&", function () {
      api.rerender('38dbee1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box-bar/BarTabConsumptionList.vue"
export default component.exports